import { useMemo } from 'react';
import { parseChartSpec, VegaChart } from '@erp/viz';
import { useGT } from 'gt-react';
import { cn } from '@/lib/utils';

interface ChartToolResultProps {
  /** The `render_chart` tool-call args: `{ spec: string, title?: string }`. */
  args: Record<string, unknown>;
  className?: string;
}

/**
 * Renders a chart that Nami drew via the `render_chart` tool, inline in the
 * chat message stream. The spec is parsed and vetted (inline-data-only) by
 * `@erp/viz`; `VegaChart` applies the app theme so it matches light/dark.
 */
export function ChartToolResult({ args, className }: ChartToolResultProps) {
  const t = useGT();
  const title = typeof args.title === 'string' ? args.title : undefined;
  const parsed = useMemo(() => parseChartSpec(args.spec), [args.spec]);

  return (
    <div
      className={cn('rounded-lg border border-border bg-card p-3', className)}
    >
      {title && (
        <div className="mb-2 text-sm font-medium text-card-foreground">
          {title}
        </div>
      )}
      {parsed.ok ? (
        <VegaChart spec={parsed.spec} height={260} />
      ) : (
        <p className="text-sm text-muted-foreground">
          {t('Unable to render chart.')} {parsed.error}
        </p>
      )}
    </div>
  );
}
